import React from 'react';
// routing
import {
  Redirect,
  Route,
} from 'react-router-dom';
// user state
import {useSelector} from 'react-redux';
import {selectUsers} from '../state/reducers/userSlice';


const PublicRoute = ({component: Component, ...rest}) => {
  const {user, isAuthenticated} = useSelector(selectUsers);


  const userAuthentication = () => {
    const token = user ? user?.token : false;

    try {
      if (

        isAuthenticated && token
      ) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  };

  const renderComponent = (props) => {
    return <Component {...props} />;
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        userAuthentication() ? (
          <Redirect
            to={{
              pathname: '/dashboard',
            }}
          />
        ) : (
          renderComponent(props)
        )
      }
    />
  );
};

export default PublicRoute;
